import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ICON_NAVIGATE_BACK, ICON_SETTLEMENT_EXCEL } from 'assets/icons';
import Row from 'components/common/Row';
import CommonImage from 'components/common/CommonImage';
import Text from 'components/common/Text';
import BasicButton from 'components/Button/BasicButton';
import CommonFilter from 'components/common/CommonFilter';
import Column from 'components/common/Column';
import { InvoiceFilter } from '../graphQL/hooks/useQueryGetInvoiceList';
import { useMutationInvoicesFile } from '../graphQL/hooks/useMutationInvoicesFile';
import CommonDialog from 'components/Modal/CommonDialog';
import { HEADER_HEIGHT } from 'constants/style';

interface RequestListHeaderIProps {
  isMobile: boolean;
  invoiceFilter: InvoiceFilter;
  isAcceptFilter: boolean;
  handleOpenSearchModal: () => void;
}

const RequestListHeader: React.FC<RequestListHeaderIProps> = props => {
  const { isMobile, invoiceFilter, isAcceptFilter, handleOpenSearchModal } =
    props;
  const { isFailed, handleGenerateInvoicesFile, handleCloseFailedDialog } =
    useMutationInvoicesFile();

  const navigate = useNavigate();
  const [showNoticeDialog, setShowNoticeDialog] = useState<boolean>(false);

  const handleNavigateBack = () => {
    navigate(-1);
  };

  const handleRequestExcel = () => {
    if (isMobile) {
      setShowNoticeDialog(true);
      return;
    }

    handleGenerateInvoicesFile(invoiceFilter.filter);
  };

  const renderContent = (): JSX.Element => {
    return (
      <>
        <Row gap="16px">
          <CommonImage src={ICON_NAVIGATE_BACK} onClick={handleNavigateBack} />
          <Text
            color="#1b1c1e"
            size="24px"
            style={{ lineHeight: '36px' }}
            weight={isMobile ? 500 : 400}
          >
            지급 요청 내역
          </Text>
        </Row>
        <Row gap="16px">
          <CommonFilter
            isAcceptFilter={isAcceptFilter}
            onClick={handleOpenSearchModal}
          />
          <BasicButton
            content={
              <Row gap="4px">
                <CommonImage
                  src={ICON_SETTLEMENT_EXCEL}
                  onClick={handleRequestExcel}
                />
                <Text color="#414B56" weight={600}>
                  내역 내려받기
                </Text>
              </Row>
            }
            onClick={handleRequestExcel}
            style={{
              padding: '8px 12px',
              borderRadius: '12px',
              background: '#f7f7f8',
              border: 'none',
            }}
          />
        </Row>
      </>
    );
  };

  const renderContents = (): JSX.Element => {
    if (isMobile) {
      return (
        <Column
          gap="24px"
          align="flex-start"
          style={{
            position: 'sticky',
            top: 0,
            padding: '32px 0',
            background: '#fff',
          }}
        >
          {renderContent()}
        </Column>
      );
    }

    return (
      <Row
        justifyContent="space-between"
        style={{
          position: 'sticky',
          top: HEADER_HEIGHT,
          padding: '40px 0',
          width: '100%',
          background: '#fff',
        }}
      >
        {renderContent()}
      </Row>
    );
  };

  return (
    <>
      {renderContents()}
      {isFailed && (
        <CommonDialog
          title="지급 요청 내역을 내려받을 수 없어요"
          description="선택한 기간에는 내려받을 내역이 없어요, 필터에서 조회기간을 다시 확인해 주세요"
          onAcceptText="네, 확인했어요"
          onAccept={handleCloseFailedDialog}
        />
      )}
      {showNoticeDialog && (
        <CommonDialog
          title="모바일에선 엑셀 내려받을 수 없어요"
          description="PC 웹 브라우저에서 이용해 주세요."
          onAcceptText="네, 확인했어요"
          onAccept={() => {
            setShowNoticeDialog(false);
          }}
        />
      )}
    </>
  );
};

export default RequestListHeader;
